/**
 * Top-level party lists of the block project-parties ("Geschäftspartner"). Must match
 * `ProjectPartiesInput` in the API schema; `createPayload` reuses `toProjectPartiesInput`.
 */
export const PROJECT_PARTIES_INPUT_FIELDS = [
  'projectRightsOwners',
  'projectRightsBrokers',
  'investors',
  'investorBrokers',
];

const toPartyIds = (parties) => (parties || []).map((party) => party._id || party);

/**
 * `ProjectPartiesInput` from the block object (or the stored project): the ids of each list, a
 * missing list as `[]`.
 */
export const toProjectPartiesInput = (project) =>
  Object.fromEntries(
    PROJECT_PARTIES_INPUT_FIELDS.map((field) => [field, toPartyIds(project[field])])
  );
